import React from "react";
import { contact_links } from "../../NavBarData";
import "./ContactNavbar.style.css";
function ContactNavbar() {
  return (
    <div className="contact-navbar">
      <div className="social-links mt-3 text-center">
        {contact_links.map((link) => {
          return (
            <a href={link.link} key={link.link}>
              {link.icon}
            </a>
          );
        })}
      </div>
    </div>
  );
}

export default ContactNavbar;
